// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"3d23fb42","47":"3d23fb42","258":"3d23fb42","391":"3d23fb42","735":"3d23fb42","764":"3d23fb42","766":"3d23fb42","794":"3d23fb42"}[chunkId] + ".chunk.css";
};